import {Component, input} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-loader',
  imports: [
    MatProgressSpinner,
  ],
  templateUrl: './loader.html',
  styleUrl: './loader.scss'
})
export class Loader {
  public isLoading = input.required<boolean>();
}
